
var dlbs = [{"name":"head-dlb/bundle.production.js","path":"head-dlb/static-1.5007/bundle.production.js","ids":{}}];
__webpack_require__.dlbpr = function(dlbId, id) {
  var dlb = dlbs[dlbId];
  if (!dlb.r) {
    var dlbNs = window['__dlb_' + dlb.path + '__'] || window['__dlb_' + dlb.name + '__'];
    if (dlbNs) {
      dlb.r = dlbNs.create(__webpack_require__, dlb.ids);
    } else {
      dlb.r = window['__webpack_require_' + dlb.path + '__'] || window['__webpack_require_' + dlb.name + '__'];
      if (!dlb.r) {
        throw new Error('dlb ' + dlb.name + ' not loaded');
      }
      dlb.r.linkDlb(__webpack_require__, dlb.ids);
    }
  }
  return dlb.r(id);
}
